import styled from 'styled-components';
import MuiInfoIcon from '@material-ui/icons/InfoOutlined';
//
import colors from 'theme/colors';

const { darkInputBorder } = colors;

export default styled(MuiInfoIcon)`
  color: ${darkInputBorder};
  width: 0.9em !important;
  margin-left: 8px;
`;
